"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONEUnfiToken = exports.ONEUpToken = exports.ONEWrappedToken = exports.ONENativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.ONENativeToken = new utils_1.Currency("ONE", 18, "ONE", "Harmony");
exports.ONEWrappedToken = new utils_1.Currency("0xcf664087a5bb0237a0bad6742852ec6c8d69a27a", 18, "WONE", "WONE");
exports.ONEUpToken = new utils_1.Currency("0xe3c46e5F7a2aD3f7e69c92FeB1c8a5d846Fa9B6f", 18, "UP", "UP");
exports.ONEUnfiToken = new utils_1.Currency("0xEe7207c782d6937BE63E38FCF902fF59E5498386", 18, "UNFI", "UNFI");
